import Vue from "vue";
import VueRouter from "vue-router";
import authRoutes from "@/_auth/authRoutes";
import UserRoutes from './app_routes/UserRoutes';
import ExecutionRoutes from './app_routes/ExecutionRoutes';
import DepartmentRoutes from './app_routes/DepartmentRoutes';
import CategoryRoutes from './app_routes/CategoryRoutes';
import ConsolidationRoutes from './app_routes/ConsolidationRoutes';

import store from '../store'


Vue.use(VueRouter);

const routes = [
  ...authRoutes,
  ...UserRoutes,
  ...ExecutionRoutes,
  ...DepartmentRoutes,
  ...CategoryRoutes,
  ...ConsolidationRoutes,
  {
    path: "/account",
    name: "Account",
    component: () => import("../pages/Account.vue"),
    meta: {
      auth: true,
      roles: ['admin', 'super_admin', 'execute']
    }
  },
  {
    path: '*',
    name: 'Err404',
    component: () => import('@/pages/Err404.vue'),
    roles: ['admin', 'super_admin', 'execute']
  },
];


Vue.router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

Vue.router.beforeEach(async(to, from, next) => {
  document.title = 'PRODMAN'
  if (to.name.toLowerCase() != 'login'){
    if (!store.state.User.user && localStorage.auth_token_default){
      await Vue.prototype.$auth.fetch()
    }
    if (store.state.User.user && to.meta.roles && to.meta.roles.includes(store.state.User.user.role.name)){
      next()
    } else if(!to.meta.roles){
      next()
    } else{
      let noti = {
        type: 'error',
        msg: 'Você não tem permissão para acessar esse recurso'
      }
      store.dispatch('Notification/add', noti)
      next('/')
    }
    next()
  } else {
    next()
  }
})


export default Vue.router;
